import {
  BUNDLE_CREATE_PATH,
  BUNDLE_DRAWER_SEGMENT,
} from "shared-ui/src/components/ecommerce/bundles/useRoutedBundleOverlays";

/** Dialogs the bundle configuration tab opens beneath both the edit drawer and the create wizard. */
const BUNDLE_CONFIGURATION_DIALOG_PATHS = [
  "add-products",
  "option-settings/:sectionId/:productId",
];

/** Edit drawer and create wizard overlays under a storefront bundles base, for `allowedOverlayPath`. */
export const bundleOverlayPaths = (base: string): string[] =>
  [
    `${base}/${BUNDLE_DRAWER_SEGMENT}/:bundleId`,
    `${base}/${BUNDLE_CREATE_PATH}`,
  ].flatMap((overlayBase) => [
    overlayBase,
    `${overlayBase}/:tab`,
    ...BUNDLE_CONFIGURATION_DIALOG_PATHS.map(
      (dialogPath) => `${overlayBase}/configuration/${dialogPath}`,
    ),
  ]);
